import Vue from "vue";
export const fastNavigationEventBus = new Vue()